var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardUnclicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 17",
    style: {
      enableBackground: "new 0 0 24 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#999999;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,3.6C5.8,3.7,5.7,4,5.9,4.2l1.6,2.1c0.2,0.2,0.4,0.2,0.6,0.1c0.2-0.1,0.2-0.4,0.1-0.6L6.6,3.7 C6.5,3.5,6.2,3.4,6,3.6z M2.3,8.5C2.2,8.7,2.3,8.9,2.5,9l2.6,0.8c0.2,0.1,0.5-0.1,0.5-0.3c0.1-0.2,0-0.5-0.3-0.5L2.8,8.2 C2.6,8.1,2.3,8.2,2.3,8.5z M2.3,14.5c0.1,0.2,0.3,0.4,0.5,0.3L5.4,14c0.2-0.1,0.3-0.3,0.3-0.5c-0.1-0.2-0.3-0.3-0.5-0.3L2.5,14 C2.3,14,2.2,14.3,2.3,14.5z M21.7,14.5c0.1-0.2,0-0.5-0.3-0.5l-2.6-0.8c-0.2-0.1-0.5,0.1-0.5,0.3c-0.1,0.2,0,0.5,0.3,0.5l2.5,0.8 C21.4,14.9,21.6,14.7,21.7,14.5z M21.7,8.5c-0.1-0.2-0.3-0.4-0.5-0.3L18.6,9c-0.2,0.1-0.4,0.3-0.3,0.5c0.1,0.2,0.3,0.3,0.5,0.3 L21.5,9C21.7,8.9,21.8,8.7,21.7,8.5z M18,3.6c-0.2-0.1-0.5-0.1-0.6,0.1l-1.6,2.1c-0.1,0.2-0.1,0.4,0.1,0.6c0.2,0.1,0.5,0.1,0.6-0.1 l1.6-2.1C18.3,4,18.2,3.7,18,3.6z M12,1.7c-0.2,0-0.4,0.2-0.4,0.4v2.6c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4V2.1 C12.4,1.9,12.2,1.7,12,1.7z M12,16.1c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3C10.7,15.6,11.3,16.1,12,16.1z  M23.4,15.2c0.4-1.2,0.6-2.4,0.6-3.7C24,5.1,18.6,0,12,0S0,5.1,0,11.5c0,1.3,0.2,2.6,0.6,3.7l0.9-0.2c-0.4-1.1-0.6-2.2-0.6-3.5 c0-5.9,5-10.6,11.1-10.6s11.1,4.8,11.1,10.6c0,1.2-0.2,2.4-0.6,3.5L23.4,15.2z M13.2,13.1c0.6,0.4,1,1,1,1.8c0,1.2-1,2.1-2.2,2.1 s-2.2-1-2.2-2.1c0-0.7,0.4-1.4,1-1.8L12,6.8L13.2,13.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardUnclicked);
export default __webpack_public_path__ + "static/media/dashboard_unclicked.5be9c9b07667352fdd20041bb9340372.svg";
export { ForwardRef as ReactComponent };